import { Steps } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import direction from '~/utils/direction';
import { useDirection } from '~/hooks';

interface Props {
  currentStep: number;
  onChange: (current: number) => void;
}

const PayrollSteps: FC<Props> = (props) => {
  const { currentStep, onChange } = props;
  const [t] = useTranslation('payrolls');
  const [dir] = useDirection();

  return (
    <Container dir={dir}>
      <Steps current={currentStep} labelPlacement="vertical" onChange={onChange}>
        <Steps.Step title={t('Enter payment details')} />
        <Steps.Step disabled={currentStep < 1} title={t('Verify beneficiaries list')} />
        <Steps.Step disabled={currentStep < 2} title={t('Account to debit')} />
      </Steps>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  width: 100%;

  .ant-steps-label-vertical .ant-steps-item-tail {
    ${direction.margin.left(90)};
  }

  .ant-steps-label-vertical .ant-steps-item-icon {
    ${direction.margin.left(74)};
  }

  .ant-steps-label-vertical .ant-steps-item-content {
    width: 180px;
  }
`;

export default PayrollSteps;
